import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import {
	CoogoongRootView,
	CoogoongServiceView,
	CoogoongPrivacyView,
	NotFoundView
} from 'views';

// ----------------------------------------------------------------------

const RouteConfig = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		document.title = 'coogoong';
	}, [pathname]);

	return (
		<Routes>
			<Route path={'/'} element={<CoogoongRootView />} />
			<Route path={'/service'} element={<CoogoongServiceView />} />
			<Route path={'/privacy'} element={<CoogoongPrivacyView />} />
			<Route path={'*'} element={<NotFoundView />} />
		</Routes>
	);
};

export default RouteConfig;
